module.exports = __webpack_public_path__ + "static/img/matic_coin.6fc9d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matic_coin.png
// module id = dyab
// module chunks = 1